import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./css/create-quiz.css";
import axios from "axios";
import { SCHOOL_QUIZ_API_BASE_URL } from "../../../src/configs/WebService";

import {
  clearSubjectBasedClasses,
  resetQuizForm,
  setQuizForm,
  setState,
} from "./redux/slice";
import {
  createQuiz,
  fetchQuizTypes,
  fetchSubjectBasedClassesData,
  fetchSubjects,
  fetchThemes,
  imageUpload,
} from "./redux/thunk";
import { useNavigate } from "react-router-dom";
import { convertTermsToHtml } from "./utils";
import {
  fetchClassesThunk,
  fetchSubjectsByClassThunk,
} from "../QuestionBank/redux/chapterThunk";

const LevelTableCommon = ({ data = [], type }) => {
  const isAcademic = type === 1 || type === 2;
  const isThematic = type === 3 || type === 4;
  const rows = data;

  return (
    <table className="cq-table">
      <thead>
        <tr>
          {isAcademic && (
            <>
              <th>Class</th>
              <th>Subject</th>
            </>
          )}
          {isThematic && (
            <>
              <th>Parent theme</th>
              <th>Child theme</th>
              <th>Group</th>
            </>
          )}
          <th className="num">Total</th>
          <th className="num">Basic</th>
          <th className="num">Advanced</th>
          <th className="num">Ultra</th>
          <th className="num">Docmaster</th>
        </tr>
      </thead>

      <tbody>
        {rows.length === 0 ? (
          <tr>
            <td colSpan={isAcademic ? 7 : 8} className="cq-empty">
              No data available
            </td>
          </tr>
        ) : (
          rows.map((item, index) => {
            const total = Number(item.total ?? 0);
            return (
              <tr key={index} className={total === 0 ? "is-zero" : ""}>
                {isAcademic && (
                  <>
                    <td>{item.class_name || "-"}</td>
                    <td>{item.subject_name || "-"}</td>
                  </>
                )}
                {isThematic && (
                  <>
                    <td>{item.parent_theme || "-"}</td>
                    <td>{item.child_theme || "-"}</td>
                    <td>{item.group_name || "-"}</td>
                  </>
                )}
                <td className="num">{total}</td>
                <td className="num">{item.basic ?? 0}</td>
                <td className="num">{item.advanced ?? 0}</td>
                <td className="num">{item.ultra ?? 0}</td>
                <td className="num">{item.docmaster ?? 0}</td>
              </tr>
            );
          })
        )}
      </tbody>
    </table>
  );
};

export default function CreateQuiz() {
  const user = useSelector((state) => state.authSlice.user);
  console.log("user", JSON.stringify(user));
  const {
    quizForm,
    subThemes,
    selectedSubThemes,
    themes,
    quizTypesList,
    subjectsList,
    loading,
    subjectBasedClasses,
  } = useSelector((state) => state.quizManagement);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { prizeDescription } = quizForm;
  const [state, setStatee] = useState({
    allotments: [],
    icon: null,
  });
  const [groups, setGroups] = useState([]);
  const [groupId, setGroupId] = useState([]);
  const [error, setError] = useState("");
  const [countInfo, setCountInfo] = useState(null);
  const [quizType, setQuizType] = useState("");
  const [subQuizType, setSubQuizType] = useState("");

  useEffect(() => {
    dispatch(fetchClassesThunk());
    dispatch(fetchThemes());
    dispatch(fetchQuizTypes());
    fetchGroups();
    dispatch(fetchSubjects());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  useEffect(() => {
    if (quizType) {
      const defaultLevels = ["basic", "advanced", "ultra", "docmaster"];
      defaultLevels.forEach((level) => {
        handleAllotmentChange(level);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quizType]);

  useEffect(() => {
    setQuizType(1);
    setSubQuizType(1);
    dispatch(resetQuizForm());
    handleClearSubjectNTheme();
    setState({ allotments: [], icon: null });
  }, []);

  useEffect(() => {
    if (!quizType) return;
    const val = quizType === 1 ? getCompetitionTerms() : getPracticeQuizTerms();
    dispatch(setQuizForm({ key: "terms", value: val }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quizType, subQuizType]);

  useEffect(() => {
    const subject_id = quizForm?.subject_id;

    dispatch(clearSubjectBasedClasses());
    dispatch(setQuizForm({ key: "class_ids", value: [] }));
    setCountInfo(null);

    if (subject_id) {
      dispatch(
        fetchSubjectBasedClassesData({ subject_id: Number(subject_id) }),
      );
    }
  }, [dispatch, quizForm?.subject_id]);

  const handleChangeNew = (key, value) => {
    setStatee((prev) => ({ ...prev, [key]: value }));
    dispatch(resetQuizForm());
  };

  // Scope level_counts to rows that actually have a child_theme, so a
  // parent-only ("" child_theme) row can't masquerade as sub-theme data.
  const scopeCountData = (data, filterToChildThemes) => {
    if (!data) return data;
    const levelCounts = data.level_counts || [];
    const hasChildRows = levelCounts.some((row) => row.child_theme);
    const scopedRows =
      filterToChildThemes && hasChildRows
        ? levelCounts.filter((row) => row.child_theme)
        : levelCounts;
    const total_count = scopedRows.reduce(
      (sum, row) => sum + Number(row.total || 0),
      0,
    );
    return { ...data, level_counts: scopedRows, total_count };
  };

  // silent = true -> probe only: no table update, no alert.
  const getCount = async ({
    class_ids,
    theme_ids,
    group_id,
    silent = false,
    filterToChildThemes = false,
  }) => {
    const payload =
      subQuizType === 1 || subQuizType === 2
        ? { class_id: class_ids, subject_id: quizForm.subject_id }
        : subQuizType === 3 || subQuizType === 4
          ? { theme_id: theme_ids, group_id }
          : "";
    try {
      const res = await axios.post(
        "https://web1024.docmaster.in:5007/api/school/quiz/admin/get-count",
        { ...payload, quiz_type: subQuizType },
      );

      console.log("✅ API Response:", res.data);

      const scopedData = scopeCountData(res.data, filterToChildThemes);

      if (!silent) {
        setCountInfo(scopedData || []);
        alert(`Available Questions Count: ${scopedData?.total_count ?? 0}`);
      }
      return scopedData;
    } catch (err) {
      console.error("❌ getAvailableQuestionsCount error:", err);
      throw err.response?.data || err.message;
    }
  };

  const fetchGroups = async () => {
    setError("");
    try {
      const res = await axios.get(`${SCHOOL_QUIZ_API_BASE_URL}/groups`);
      const data = res?.data?.data || [];
      setGroups(data || []);
    } catch (err) {
      setError("Failed to fetch group data");
      console.error("fetchGroups error:", err);
    }
  };

  useEffect(() => {
    if (quizForm.class_id) {
      dispatch(fetchSubjectsByClassThunk(Number(quizForm.class_id)));
    }
  }, [quizForm.class_id, dispatch]);

  function formatTerms(text) {
    if (!text) return "";

    const lines = text.split("\n").filter((l) => l.trim() !== "");

    let html = "<ol>";
    let inSubList = false;

    lines.forEach((line, idx) => {
      const trimmed = line.trim();

      if (idx === 0 && !/^\d+\./.test(trimmed)) {
        html = `<h3>${trimmed}</h3><ol>`;
        return;
      }

      if (/^\d+\./.test(trimmed)) {
        if (inSubList) {
          html += "</ul>";
          inSubList = false;
        }
        const withoutNum = trimmed.replace(/^\d+\.\s*/, "");
        html += `<li><strong>${withoutNum}</strong><ul>`;
        inSubList = true;
      } else {
        if (inSubList) {
          html += `<li>${trimmed}</li>`;
        } else {
          html += `<p>${trimmed}</p>`;
        }
      }
    });

    if (inSubList) html += "</ul>";
    html += "</ol>";

    return html;
  }

  const getCompetitionTerms = () =>
    "*Hosting Legal*\n" +
    "Quiz is an initiative of DocMaster. It is a step aimed to empower its users with knowledge sharpening and rehearsals with current developments and increase in critical thinking around legal frameworks. Participating in DocMaster - Quiz is only subject to acceptance of its terms and conditions.\n\n" +
    "*Eligibility*\n" +
    "The quiz is open to all, it majorly focused for legal professionals, undergraduate and postgraduate law students from law colleges and universities.\n\n" +
    "*Registration*\n" +
    "Participants have to register first on the website of https://www.DocMaster.Legal as an advocate or a student which is totally free..\n" +
    "DocMaster will give option to practice on different topics.\n" +
    `While participating in a Quiz Competition every participant will have to submit its intent, where an OTP will be sent before the start of it.
There are no registration charges or fees applicable to participate in the Quiz.
Participants must complete personal information asked during registration. False, incomplete or misleading data may lead to disqualification or future problems to the participants.\n` +
    `Participants are expected to read all terms and conditions and guidelines before starting the use of DocMaster or to participate in the Quiz.  After registering, it would be treated a confirmation from the participants that they have gone through it and give acceptance of all terms and conditions of DocMaster.\n\n` +
    "*Quiz Format*\n" +
    "The quiz will be conducted only through online mode and would be available on https://www.DocMaster.Legal \n The Quiz schedule and timings will be announced from time to time at least 24 hours in advance.\nAll participants will themselves be responsible to check in advance their comfort and compatibility to participate, that is if they can execute the Quiz Process using laptop, desktop, tablet or by a mobile phone and their respective internet connection. The DocMaster can not be held responsible for any system glitches, slow internet or anything which arise from the side of the users. The DocMaster is not charging any fees or charges and offering its platform totally free.\n" +
    `The scoring system is designed to be calculated automatically upon each submission and shall be considered final at each level and step. No requests for re-evaluation or modification will be entertained as it’s a competition to learn and sharpen the skill. The quiz does not help in getting any degree or recognition. In the event of any technical disruption including connectivity issues, device failures or system glitches, the decision to permit re-attempts shall rest solely with DocMaster and will be considered at its discretion.\n` +
    "The overall results will be published on the dashboard immediately following the conclusion of the quiz. In the event of a tie, the participant who submits their responses earliest will be accorded a higher rank. The numbers, time and speed will be the essence of the quiz.\n" +
    "Our quiz system is designed to randomly assign and display different sets of questions to each participant during the same quiz session. This ensures a dynamic, fair, and secure assessment environment for all users.\n\n" +
    "*How to Play*\n" +
    `The quiz comprises a certain number of multiple-choice questions, each featuring four answer options. Participants will have [X seconds] seconds to respond to each question, with the timer beginning as soon as the question appears. Once the quiz starts, questions will be presented one at a time. To proceed, participants must select the correct option and click the "Submit" button to move to the next question. The quiz must be completed in a single uninterrupted session.\n\n` +
    "*Markings*\n" +
    "The quiz comprises [Number] objective questions (e.g., MCQs, case-based scenarios), with a total duration of [X seconds] seconds ([X second] seconds per question).\n\n" +
    "*Scoring, Feedback & Result Declaration*\n" +
    `Performance in the quiz will be evaluated based on “Maximum Correct Answers in the Shortest Time”, determined electronically. Thus, in case of a tie(s), the participant who completed the Quiz at the earliest shall be considered the best performer.
Each correct answer awards [Correct]
Scores are auto-generated upon submission and are final. The correct answer will be displayed after every attempt made by the user .In case of any technical failure, permitting reattempts will be the sole discretion of the DocMaster.
Overall Results will be declared on https://www.DocMaster.Legal  once the quiz duration is over.
` +
    `The quiz will cover legal domains, including and not limited to:
The upcoming quiz will cover a wide range of Indian laws, some of are listed here for your information but the question may also be raised from the acts and laws not mentioned here. These may include Constitutional Law, Civil Law, Family Law, Hindu Law, Company Law, Banking Law, Contract Law, Law of Torts, Law of Property, Law of Taxation, Insurance Law & Accidental Claims, Labour & Industrial Law, Consumer Protection, Arbitration, Conciliation & ADR, Environmental Law, Information Technology & Cyber Law, Intellectual Property Law, Land Law, Law relating to RTI, Law relating to Women & Child, Changes & Reforms, Professional Ethics, Jurisprudence, Indian Judicial System, Law and Media, Drafting of Pleading and Conveyancing and Legal English.\n` +
    "It will also include the newly introduced criminal law codes—the Bhartiya Nyaya Sanhita (BNS), Bhartiya Nagarik Suraksha Sanhita (BNSS) and Bhartiya Sakshya Adhiniyam (BSA) which have replaced the Indian Penal Code (IPC), the Code of Criminal Procedure (CrPC) and the Indian Evidence Act, respectively. This quiz will also test understanding of legal terminology and landmark judgments that have shaped Indian jurisprudence. In addition, a section will focus on features of https://www.DocMaster.legal.\n\n" +
    `*Conduct & Integrity*\n
Participants must maintain academic integrity and refrain from using unfair means, including but not limited to:` +
    "\n1.External assistance or collaboration\n 2. Use of multiple devices or accounts\n 3. Impersonation or proxy participation\n\n" +
    "Any violation will result in immediate disqualification and may be reported to the concerned institution. DocMaster reserves the right to monitor quiz activity and verify participant identity\n\n" +
    "*Data Usage & Privacy*\n" +
    "By registering, participants consent to the collection and use of their personal data for quiz administration, result processing and outreach communication. DocMaster will handle all data in accordance with its Privacy Policy, ensuring confidentiality and responsible usage. Participant data will not be sold or shared externally without informed consent, unless legally mandated.\n\n" +
    "*Legal Disclaimer*\n" +
    "Participation in the quiz constitutes a voluntary educational engagement and does not confer any legal rights, professional certification or institutional affiliation unless expressly stated by DocMaster.\n" +
    "DocMaster and its organisers shall not be held liable for any technical disruptions, personal inconveniences or academic consequences arising from participation in the quiz. Participation is voluntary, and users accept all risks associated with digital engagement.\n" +
    "Any disputes or claims related to the quiz shall be governed by the applicable laws of India and subject to the exclusive jurisdiction of the courts situated in Delhi.\n\n" +
    "*Grievance and Redressal*\n" +
    "All grievances or concerns must be formally submitted in writing to info@DocMaster.in within three days following the conclusion of the quiz. The organising committee will endeavour to review and respond within fifteen working days. All decisions made in this regard shall be final and binding.\n\n" +
    "*Amendments*\n" +
    "DocMaster solely reserves the right to revise the quiz format, schedule, content or associated terms at its discretion. Any such modifications will be duly communicated through the official website. Continued engagement with the quiz following these updates shall constitute deemed acceptance of the amended terms.\n\n" +
    "*Contact*\n" +
    `For queries, technical support or clarifications, please reach out to:
Email: info@DocMaster.in
Call us at +91 9289 44 0048
Website: https://www.DocMaster.Legal`;

  const getPracticeQuizTerms = () =>
    "1. All registered users including law students, legal interns, educators, and professionals are eligible to access practice quizzes.\n" +
    `2. This is a timed quiz with [Number] questions to be answered in [X seconds] seconds ([X second] seconds per question) but it is non-competitive.\n` +
    "3. They are designed for self-paced learning and concept reinforcement.\n" +
    "4. Scores are for personal tracking only and do not affect rankings or certification.\n" +
    "5. To Participate, user needs to register on the website.\n" +
    "6. The participants will be required to provide their name, email address, telephone number etc. By submitting the contact details, participants consent that the contact information can be used for the quiz.\n" +
    "7. The quiz will start as soon as the participant clicks the “Start Quiz” button.\n" +
    "8. Once submitted, an entry cannot be withdrawn.\n" +
    "9. A participant can participate multiple times in a practice quiz.\n" +
    "10. Topics may include Contract Law, Criminal Procedure, Environmental Law, Constitutional Law, Legal Drafting, and more.\n" +
    "11. The participant will abide by all the rules and regulations of participating in the quiz.\n" +
    "12. Quiz content is reviewed periodically to reflect changes in law, pedagogy, and user feedback.\n" +
    "13. While every effort is made to ensure accuracy, users are advised to cross-reference with official statutes, case law, and academic resources for formal study or examination.\n" +
    "14. Scores and progress may be tracked for personal use.\n" +
    "15. Practice quizzes do not contribute to rankings, certifications, or rewards unless explicitly stated.\n" +
    "16. Data may be used anonymously to improve platform recommendations and learning analytics.\n" +
    "17. No personal data is shared with third parties without consent.\n" +
    "18. Users must maintain academic integrity while using the platform. Any attempt to manipulate scores, impersonate users, or misuse content may result in restricted access or account suspension.\n" +
    "19. DocMaster.Legal is not liable for any academic, professional, or legal outcomes resulting from quiz use.\n" +
    "20. Practice quizzes are supplementary tools and do not replace formal legal education or professional advice.\n" +
    "21. By entering the quiz, the participant accepts and agrees to the terms and conditions mentioned above." +
    "*Scoring, Feedback & Result Declaration*\n" +
    "Performance in the quiz will be evaluated based on “Maximum Correct Answers in the Shortest Time”, determined electronically. Thus, in case of a tie(s), the participant who completed the Quiz at the earliest shall be considered the best performer." +
    "Each correct answer awards [Correct]\n" +
    `Scores are auto-generated upon submission and are final.
The correct answer will be displayed after every attempt made by the user
In case of any technical failure, permitting reattempts will be the sole discretion of the DocMaster.\n` +
    "Overall Results will be declared on https://www.DocMaster.Legal  once the quiz duration is over.\n" +
    `The quiz will cover legal domains, including and not limited to:
The upcoming quiz will cover a wide range of Indian laws, some of are listed here for your information but the question may also be raised from the acts and laws not mentioned here. These may include Constitutional Law, Civil Law, Family Law, Hindu Law, Company Law, Banking Law, Contract Law, Law of Torts, Law of Property, Law of Taxation, Insurance Law & Accidental Claims, Labour & Industrial Law, Consumer Protection, Arbitration, Conciliation & ADR, Environmental Law, Information Technology & Cyber Law, Intellectual Property Law, Land Law, Law relating to RTI, Law relating to Women & Child, Changes & Reforms, Professional Ethics, Jurisprudence, Indian Judicial System, Law and Media, Drafting of Pleading and Conveyancing and Legal English.
\n` +
    "It will also include the newly introduced criminal law codes—the Bhartiya Nyaya Sanhita (BNS), Bhartiya Nagarik Suraksha Sanhita (BNSS) and Bhartiya Sakshya Adhiniyam (BSA) which have replaced the Indian Penal Code (IPC), the Code of Criminal Procedure (CrPC) and the Indian Evidence Act, respectively. This quiz will also test understanding of legal terminology and landmark judgments that have shaped Indian jurisprudence. In addition, a section will focus on features of https://www.DocMaster.legal." +
    "";

  const handleChange = (key, value) => {
    dispatch(setQuizForm({ key, value }));
  };

  useEffect(() => {
    if (quizForm.theme_id) {
      const filtered =
        themes.find((e) => e.theme_id === Number(quizForm.theme_id))
          ?.sub_theme || [];
      dispatch(setState({ key: "subThemes", value: filtered }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quizForm.theme_id]);

  const removeAllotment = (difficulty_level) => {
    setStatee((prev) => ({
      ...prev,
      allotments: prev.allotments.filter(
        (a) => a.difficulty_level !== difficulty_level,
      ),
    }));
  };

  const handleAllotmentChange = (difficulty_level) => {
    if (
      !state.allotments.some(
        (item) => item.difficulty_level === difficulty_level,
      )
    ) {
      setStatee((prev) => ({
        ...prev,
        allotments: [...prev.allotments, { difficulty_level, percentage: "" }],
      }));
    }
  };

  const updatePercent = (index, value) => {
    const updated = [...state.allotments];
    updated[index].percentage = value;
    setStatee((prev) => ({ ...prev, allotments: updated }));
  };

  // Class checkbox (subQuizType 1 & 2): probe the class first, only check it
  // if it actually has questions for the selected subject.
  const handleClassCheckboxToggle = async (cls, checked) => {
    const classId = cls.class_id;
    const currentIds = Array.isArray(quizForm?.class_ids)
      ? [...quizForm.class_ids]
      : [];

    if (checked) {
      try {
        const probe = await getCount({
          class_ids: [classId],
          theme_ids: [],
          group_id: "",
          silent: true,
        });

        if (!probe || Number(probe.total_count) <= 0) {
          alert(
            `"${cls.class_name}" has no questions available for the selected subject. Please choose a different class.`,
          );
          return;
        }

        const updatedIds = [...currentIds, classId];
        dispatch(setQuizForm({ key: "class_ids", value: updatedIds }));
        await getCount({ class_ids: updatedIds, theme_ids: [], group_id: "" });
      } catch (err) {
        console.error("Error verifying class question count:", err);
        alert(
          "Could not verify question availability for this class. Please try again.",
        );
      }
    } else {
      const updatedIds = currentIds.filter((id) => id !== classId);
      dispatch(setQuizForm({ key: "class_ids", value: updatedIds }));
      if (updatedIds.length > 0) {
        await getCount({ class_ids: updatedIds, theme_ids: [], group_id: "" });
      } else {
        setCountInfo(null);
      }
    }
  };

  // Sub-theme checkbox (subQuizType 3 & 4): same probe-before-check pattern.
  const handleSubThemeCheckboxToggle = async (themeId, checked) => {
    const selected = selectedSubThemes || [];

    if (checked) {
      if (groupId.length > 0) {
        try {
          const availability = await Promise.all(
            groupId.map(async (selectedGroupId) => {
              const probe = await getCount({
                class_ids: [],
                theme_ids: [themeId],
                group_id: [selectedGroupId],
                silent: true,
                filterToChildThemes: true,
              });
              return {
                groupId: selectedGroupId,
                hasQuestions: Number(probe?.total_count) > 0,
              };
            }),
          );
          const compatibleGroups = availability
            .filter(({ hasQuestions }) => hasQuestions)
            .map(({ groupId: selectedGroupId }) => selectedGroupId);

          if (compatibleGroups.length === 0) {
            alert(
              "The selected sub-theme has no questions available for the chosen group(s). Please choose a different sub-theme.",
            );
            return;
          }

          const updatedList = [...selected, themeId];

          if (compatibleGroups.length !== groupId.length) {
            setGroupId(compatibleGroups);
          }
          dispatch(setState({ key: "selectedSubThemes", value: updatedList }));

          await getCount({
            class_ids: [],
            theme_ids: updatedList,
            group_id: compatibleGroups,
            filterToChildThemes: true,
          });
          return;
        } catch (err) {
          console.error("Error verifying sub-theme question count:", err);
          alert(
            "Could not verify question availability for this sub-theme. Please try again.",
          );
          return;
        }
      }

      const updatedList = [...selected, themeId];
      dispatch(setState({ key: "selectedSubThemes", value: updatedList }));
    } else {
      const updatedList = selected.filter((id) => Number(id) !== themeId);
      dispatch(setState({ key: "selectedSubThemes", value: updatedList }));

      if (groupId?.length > 0) {
        if (updatedList.length > 0) {
          await getCount({
            class_ids: [],
            theme_ids: updatedList,
            group_id: groupId,
            filterToChildThemes: true,
          });
        } else {
          setCountInfo(null);
        }
      }
    }
  };

  // Group checkbox (subQuizType 3 & 4): same probe-before-check pattern.
  const handleGroupCheckboxToggle = async (group, checked) => {
    const gId = group.group_id;
    const hasSubThemesSelected = selectedSubThemes?.length > 0;
    const themeIdsForProbe = quizForm.theme_id
      ? hasSubThemesSelected
        ? selectedSubThemes.map(Number)
        : [Number(quizForm.theme_id)]
      : [];

    if (checked) {
      try {
        const probe = await getCount({
          class_ids: [],
          theme_ids: themeIdsForProbe,
          group_id: [gId],
          silent: true,
          filterToChildThemes: hasSubThemesSelected,
        });

        if (!probe || Number(probe.total_count) <= 0) {
          alert(
            `"${group.group_name}" has no questions available for the selected theme. Please choose a different group.`,
          );
          return;
        }

        const updatedGroups = [...groupId, gId];
        setGroupId(updatedGroups);
        await getCount({
          class_ids: [],
          theme_ids: themeIdsForProbe,
          group_id: updatedGroups,
          filterToChildThemes: hasSubThemesSelected,
        });
      } catch (err) {
        console.error("Error verifying group question count:", err);
        alert(
          "Could not verify question availability for this group. Please try again.",
        );
      }
    } else {
      const updatedGroups = groupId.filter((id) => id !== gId);
      setGroupId(updatedGroups);
      if (updatedGroups.length > 0) {
        await getCount({
          class_ids: [],
          theme_ids: themeIdsForProbe,
          group_id: updatedGroups,
          filterToChildThemes: hasSubThemesSelected,
        });
      } else {
        setCountInfo(null);
      }
    }
  };

  // Safe read: no crash when "user" is missing from localStorage.
  // const userStr = localStorage.getItem("user");
  // const parsedUser = userStr ? JSON.parse(userStr) : null;
  const userId = user?.id ?? "";
  const schoolId = user?.admin_id ?? "";

  const validateQuizForm = () => {
    const errors = [];

    if (!quizType) errors.push("Quiz Type (Live/Practice)");
    if (!subQuizType) errors.push("Sub Quiz Type");

    if (!quizType || !subQuizType) {
      return errors.join(", ");
    }

    if (!quizForm.title?.trim()) errors.push("Quiz Title");

    if (quizType === 1) {
      if (!quizForm.registrationStart) errors.push("Registration Start Date");
      if (!quizForm.registrationEnd) errors.push("Registration End Date");
      if (!quizForm.start) errors.push("Quiz Start Date");

      if (
        quizForm.registrationStart &&
        quizForm.registrationEnd &&
        quizForm.start
      ) {
        const now = Date.now();
        const regStart = Date.parse(quizForm.registrationStart);
        const regEnd = Date.parse(quizForm.registrationEnd);
        const startDate = Date.parse(quizForm.start);

        if (isNaN(regStart) || isNaN(regEnd) || isNaN(startDate)) {
          errors.push("Valid Registration/Quiz Dates");
        } else {
          if (regStart <= now) {
            errors.push("Registration Start Date (must be in the future)");
          }
          if (regEnd <= regStart) {
            errors.push("Registration End Date (must be after start date)");
          }
          if (startDate <= regEnd) {
            errors.push(
              "Quiz Start Date (must be after registration end date)",
            );
          }
        }
      }

      if (!quizForm.registrationFeeMode) {
        errors.push("Registration Fee Mode (Free/Paid)");
      }
      if (
        quizForm.registrationFeeMode === "paid" &&
        (!quizForm.registrationCost || Number(quizForm.registrationCost) <= 0)
      ) {
        errors.push("Registration Cost");
      }

      if (
        !Number(quizForm.totalQuestions) ||
        Number(quizForm.totalQuestions) <= 0
      ) {
        errors.push("Total Question(s)");
      }
      if (
        !Number(quizForm.questionDuration) ||
        Number(quizForm.questionDuration) <= 0
      ) {
        errors.push("Duration per Question");
      }
      if (
        countInfo &&
        Number(quizForm.totalQuestions) > Number(countInfo?.total_count)
      ) {
        errors.push(
          `Total Questions (must not exceed ${countInfo?.total_count})`,
        );
      }
    }

    if (quizType === 2) {
      if (!state.icon) errors.push("Icon for the Quiz");
      if (
        !Number(quizForm.totalQuestions) ||
        Number(quizForm.totalQuestions) <= 0
      ) {
        errors.push("Total Question(s)");
      }
      if (
        !Number(quizForm.questionDuration) ||
        Number(quizForm.questionDuration) <= 0
      ) {
        errors.push("Question Duration");
      }
      if (
        countInfo &&
        Number(quizForm.totalQuestions) > Number(countInfo?.total_count)
      ) {
        errors.push(
          `Total Questions (must not exceed ${countInfo?.total_count})`,
        );
      }
    }

    if (
      quizForm.correct === "" ||
      quizForm.correct === undefined ||
      Number(quizForm.correct) <= 0
    ) {
      errors.push("Marks For Correct Answer");
    }
    if (
      quizForm.enableWrongMarks &&
      (quizForm.wrong === "" ||
        quizForm.wrong === undefined ||
        quizForm.wrong === null)
    ) {
      errors.push("Negative Marks For Wrong Answer");
    }
    if (
      quizForm.enableSkippedMarks &&
      (quizForm.skipped === "" ||
        quizForm.skipped === undefined ||
        quizForm.skipped === null)
    ) {
      errors.push("Negative Marks For Skipped Answer");
    }

    if (subQuizType === 1 || subQuizType === 2) {
      if (!quizForm.subject_id) errors.push("Subject");
      if (
        !Array.isArray(quizForm.class_ids) ||
        quizForm.class_ids.length === 0
      ) {
        errors.push("Class(es)");
      }
    }

    if (subQuizType === 3 || subQuizType === 4) {
      if (!quizForm.theme_id) errors.push("Theme");
      if (!groupId || groupId.length === 0) errors.push("Group");
    }

    if (quizType === 1) {
      const totalPercentage = state.allotments.reduce(
        (sum, a) => sum + Number(a.percentage || 0),
        0,
      );
      if (totalPercentage !== 100) {
        errors.push("Difficulty Allotments (must total exactly 100%)");
      }
      if (state.allotments.some((a) => Number(a.percentage) < 0)) {
        errors.push("Difficulty Allotments (cannot be negative)");
      }
    }

    if (quizType === 1 && !prizeDescription) {
      errors.push("Winner Prize Details");
    }

    if (!quizForm.about?.trim()) errors.push("About Quiz");
    if (!quizForm.terms?.trim()) errors.push("Terms and Conditions");

    return errors.length > 0 ? errors.join(", ") : null;
  };

  const handleSubmit = async () => {
    const validationError = validateQuizForm();
    if (validationError) {
      alert(`Please fill/fix the following: ${validationError}`);
      return;
    }

    const isPracticeQuiz = quizType === 2;
    const isLiveQuiz = quizType === 1;

    if (
      countInfo &&
      Number(quizForm.totalQuestions) > Number(countInfo?.total_count)
    ) {
      alert(`Maximum questions should be ${countInfo?.total_count}`);
      return;
    }
    if (
      isLiveQuiz &&
      state.allotments.reduce(
        (sum, a) => sum + Number(a.percentage || 0),
        0,
      ) !== 100
    ) {
      alert("Total percentage of difficulty allotments must be exactly 100%");
      return;
    }

    const now = Date.now();
    const regStart = Date.parse(quizForm.registrationStart);
    const regEnd = Date.parse(quizForm.registrationEnd);
    const startDate = Date.parse(quizForm.start);

    if (isLiveQuiz) {
      if (regStart <= now) {
        alert("Registration start date must be in the future.");
        return;
      }
      if (regEnd <= regStart) {
        alert("Registration end date must be after registration start date.");
        return;
      }
      if (startDate <= regEnd) {
        alert("Start date of quiz must be after registration end date.");
        return;
      }
    }

    if (quizType === 2 && !state.icon) {
      alert("Please upload the icon for the practice quiz");
    } else {
      const commonBody = {
        title: quizForm.title,
        total_questions: Number(quizForm.totalQuestions),
        duration_per_question: Number(quizForm.questionDuration),
        marks_per_question: Number(quizForm.correct),
        negative_marks_wrong: Number(quizForm.wrong),
        negative_marks_skipped: Number(quizForm.skipped),
        about_quiz: quizForm.about,
        quiz_terms: quizForm.terms,
        quiz_type: Number(subQuizType),
        user_id: userId,
        school_id: schoolId,
      };

      const body = isLiveQuiz
        ? {
            ...commonBody,
            allotments: state.allotments.filter(
              (a) => Number(a.percentage) > 0,
            ),
            registration_start_date: quizForm.registrationStart,
            registration_end_date: quizForm.registrationEnd,
            registration_fee:
              quizForm.registrationFeeMode === "free"
                ? 0
                : parseFloat(quizForm.registrationCost).toFixed(2),
            prizes: prizeDescription,
            start_date: quizForm.start,
            registration_type: quizForm.registrationFeeMode,

            ...(subQuizType === 1
              ? {
                  subject_id: quizForm.subject_id
                    ? Number(quizForm.subject_id)
                    : null,
                  class_id: quizForm.class_ids ? quizForm.class_ids : null,
                }
              : subQuizType === 3
                ? {
                    group_id: groupId,
                    theme_id: quizForm.theme_id
                      ? selectedSubThemes?.length
                        ? selectedSubThemes
                        : [quizForm.theme_id]
                      : [],
                  }
                : {}),
          }
        : isPracticeQuiz
          ? {
              ...commonBody,
              ...(subQuizType === 2
                ? {
                    subject_id: quizForm.subject_id
                      ? Number(quizForm.subject_id)
                      : null,
                    class_id: quizForm.class_ids ? quizForm.class_ids : null,
                  }
                : subQuizType === 4
                  ? {
                      group_id: groupId,
                      theme_id: quizForm.theme_id
                        ? selectedSubThemes?.length
                          ? selectedSubThemes
                          : [quizForm.theme_id]
                        : [],
                    }
                  : {}),
            }
          : { ...commonBody };

      console.log("Body to send", body);

      if (window.confirm("Are you sure to create quiz")) {
        try {
          const res = await dispatch(createQuiz(body));
          if (quizType === 2) {
            const res2 = await dispatch(
              imageUpload({
                image: state.icon,
                id: res?.payload?.quiz_id,
                quiz_type: subQuizType,
              }),
            );
            if (res2) {
              alert(res2?.payload?.message || "image uploaded!");
            }
          }

          if (res) {
            if (res?.payload?.message === "Missing required fields") {
              alert(res?.payload?.message);
              navigate("/dashboard/create-school-quiz");
            } else {
              alert(res?.payload?.message || "Quiz created successfully");
              setStatee({ allotments: [] });
              dispatch(resetQuizForm());
              navigate("/viewOrUpdateQuiz");
            }
          }
        } catch (err) {
          console.error("Error creating quiz:", err);
          alert("Error creating quiz");
        }
      }
    }
  };

  const totalAllotment =
    quizType === 1
      ? state.allotments.reduce((sum, a) => sum + Number(a.percentage || 0), 0)
      : 0;

  const filteredList =
    quizType === 1
      ? (quizTypesList?.data?.filter((e) => e.is_live === 1) ?? [])
      : quizType === 2
        ? (quizTypesList?.data?.filter((e) => e.is_live === 0) ?? [])
        : [];

  function handleClearSubjectNTheme() {
    setCountInfo(null);
    handleChange("subject_id", "");
    setGroupId([]);
    dispatch(setQuizForm({ key: "class_ids", value: [] }));
  }

  // ======================= RENDER =======================
  return (
    <>
      {user?.payments?.some((payment) => payment.model_id === 3) && (
        <div className="cq-page">
          <div className="cq-shell">
            <h1 className="cq-title">Create quiz</h1>
            <p className="cq-subtitle">
              Choose a quiz type, set up its questions, then create it.
            </p>

            {/* ---------- Quiz type ---------- */}
            <section className="cq-section">
              <h3 className="cq-section__title">Quiz type</h3>
              <div className="cq-grid">
                {quizType && (
                  <div className="cq-field">
                    <div className="cq-segment">
                      {filteredList.map((quiz) => (
                        <label key={quiz.id}>
                          <input
                            type="radio"
                            name="subQuizType"
                            value={quiz.id}
                            checked={subQuizType === quiz.id}
                            onChange={(e) => {
                              setSubQuizType(Number(e.target.value));
                              dispatch(resetQuizForm());
                              handleClearSubjectNTheme();
                              setState({ allotments: [], icon: null });
                            }}
                            disabled={loading}
                          />
                          <span>
                            {quiz.type.charAt(0).toUpperCase() +
                              quiz.type.slice(1)}
                          </span>
                        </label>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </section>

            {quizType === "" ? (
              <p className="cq-empty">Choose a quiz type to continue.</p>
            ) : (
              <>
                {/* ---------- Basics ---------- */}
                <section className="cq-section">
                  <h3 className="cq-section__title">Quiz title</h3>
                  <div className="cq-field">
                    <input
                      type="text"
                      className="cq-input"
                      placeholder="Enter quiz title"
                      value={quizForm.title}
                      onChange={(e) => handleChange("title", e.target.value)}
                      required
                      maxLength={30}
                    />
                    <span className="cq-help">{quizForm?.title.length}/30</span>
                  </div>
                </section>

                {/* ---------- Registration (Live only) ---------- */}
                {quizType === 1 && (
                  <section className="cq-section">
                    <h3 className="cq-section__title">Registration details</h3>
                    <p className="cq-section__hint">
                      Registration must open in the future and close before the
                      quiz starts.
                    </p>
                    <div className="cq-grid">
                      {["registrationStart", "registrationEnd", "start"].map(
                        (key, idx) => (
                          <div className="cq-field" key={key}>
                            <label className="cq-label">
                              {
                                [
                                  "Registration start",
                                  "Registration end",
                                  "Quiz date",
                                ][idx]
                              }
                            </label>
                            <input
                              type="datetime-local"
                              className="cq-input"
                              value={quizForm[key]}
                              onChange={(e) =>
                                handleChange(key, e.target.value)
                              }
                              required
                            />
                          </div>
                        ),
                      )}

                      <div className="cq-field">
                        <span className="cq-label">Registration fee</span>
                        <div className="cq-segment">
                          {["free", "paid"].map((mode) => (
                            <label key={mode}>
                              <input
                                type="radio"
                                name="registrationFeeMode"
                                value={mode}
                                checked={quizForm.registrationFeeMode === mode}
                                onChange={(e) =>
                                  handleChange(
                                    "registrationFeeMode",
                                    e.target.value,
                                  )
                                }
                                required
                              />
                              <span style={{ textTransform: "capitalize" }}>
                                {mode}
                              </span>
                            </label>
                          ))}
                        </div>
                      </div>

                      {quizForm.registrationFeeMode === "paid" && (
                        <div className="cq-field">
                          <label className="cq-label">Registration cost</label>
                          <input
                            type="number"
                            className="cq-input"
                            value={quizForm.registrationCost}
                            onChange={(e) =>
                              handleChange("registrationCost", e.target.value)
                            }
                            required
                            min="1"
                          />
                        </div>
                      )}
                    </div>
                  </section>
                )}

                {/* ---------- Question details ---------- */}
                <section className="cq-section">
                  <h3 className="cq-section__title">Question details</h3>
                  <div className="cq-grid">
                    <div className="cq-field">
                      <label className="cq-label">Total questions</label>
                      <input
                        type="number"
                        min={1}
                        className="cq-input"
                        value={quizForm.totalQuestions}
                        onChange={(e) =>
                          handleChange("totalQuestions", Number(e.target.value))
                        }
                        required
                      />
                    </div>
                    <div className="cq-field">
                      <label className="cq-label">
                        {quizType === 1
                          ? "Duration per question (seconds)"
                          : "Question duration (seconds)"}
                      </label>
                      <input
                        type="number"
                        min={1}
                        className="cq-input"
                        value={quizForm.questionDuration}
                        onChange={(e) =>
                          handleChange(
                            "questionDuration",
                            Number(e.target.value),
                          )
                        }
                        required
                      />
                    </div>
                    {quizType === 1 && (
                      <div className="cq-field">
                        <label className="cq-label">
                          Total duration (seconds)
                        </label>
                        <input
                          type="number"
                          className="cq-input"
                          disabled
                          value={`${
                            quizForm.questionDuration * quizForm.totalQuestions
                          }`}
                          readOnly
                        />
                      </div>
                    )}
                  </div>

                  {countInfo && (
                    <div className="cq-availability">
                      <div className="cq-availability__head">
                        <span>Available questions</span>
                        <span className="cq-availability__count">
                          {countInfo?.total_count}
                        </span>
                      </div>
                      <div className="cq-table-wrap">
                        <LevelTableCommon
                          data={countInfo.level_counts || []}
                          type={subQuizType}
                        />
                      </div>
                    </div>
                  )}
                </section>

                {/* ---------- Marks ---------- */}
                <section className="cq-section">
                  <h3 className="cq-section__title">Marking</h3>
                  <div className="cq-grid">
                    <div className="cq-field">
                      <label className="cq-label">
                        Marks for correct answer
                      </label>
                      <input
                        type="number"
                        className="cq-input"
                        value={quizForm.correct}
                        onChange={(e) =>
                          handleChange("correct", e.target.value)
                        }
                        required
                        min="1"
                      />
                    </div>

                    {[
                      {
                        key: "enableWrongMarks",
                        label: "Negative marking for wrong answer",
                        inputKey: "wrong",
                      },
                      {
                        key: "enableSkippedMarks",
                        label: "Negative marking for skipped answer",
                        inputKey: "skipped",
                      },
                    ].map(({ key, label, inputKey }) => (
                      <div className="cq-field" key={key}>
                        <label
                          className="cq-chip"
                          style={{ alignSelf: "flex-start" }}
                        >
                          <input
                            type="checkbox"
                            checked={!!quizForm[key]}
                            onChange={(e) =>
                              handleChange(key, e.target.checked)
                            }
                          />
                          {label}
                        </label>
                        {quizForm[key] && (
                          <input
                            type="number"
                            className="cq-input"
                            placeholder={`Marks for ${inputKey}`}
                            value={quizForm[inputKey]}
                            min="0"
                            onChange={(e) =>
                              handleChange(inputKey, e.target.value)
                            }
                          />
                        )}
                      </div>
                    ))}
                  </div>
                </section>

                {/* ---------- Subject + class (sub types 1 & 2) ---------- */}
                {(subQuizType === 1 || subQuizType === 2) && (
                  <section className="cq-section">
                    <h3 className="cq-section__title">Subject and classes</h3>
                    <p className="cq-section__hint">
                      A class can only be selected if it has questions for the
                      chosen subject.
                    </p>
                    <div className="cq-grid">
                      <div className="cq-field cq-field--wide">
                        <label className="cq-label">Subject</label>
                        <select
                          className="cq-select"
                          name="subject_id"
                          value={quizForm?.subject_id || ""}
                          onChange={(e) =>
                            handleChange("subject_id", e.target.value)
                          }
                        >
                          <option value="">Select subject</option>
                          {(subjectsList?.data || []).map((s) => (
                            <option key={s.subject_id} value={s.subject_id}>
                              {s.subject_name}
                            </option>
                          ))}
                        </select>
                      </div>

                      {quizForm.subject_id && (
                        <div className="cq-field cq-field--wide">
                          <span className="cq-label">Classes</span>
                          {subjectBasedClasses?.length === 0 && (
                            <p className="cq-error">
                              No classes found for the selected subject.
                            </p>
                          )}
                          <div className="cq-chips">
                            {(subjectBasedClasses?.data || []).map((cls) => (
                              <label key={cls.class_id} className="cq-chip">
                                <input
                                  type="checkbox"
                                  name="class_ids"
                                  value={cls.class_id}
                                  checked={
                                    Array.isArray(quizForm?.class_ids) &&
                                    quizForm.class_ids.includes(cls.class_id)
                                  }
                                  onChange={(e) =>
                                    handleClassCheckboxToggle(
                                      cls,
                                      e.target.checked,
                                    )
                                  }
                                  disabled={loading || !quizForm?.subject_id}
                                />
                                {cls.class_name}
                              </label>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  </section>
                )}

                {/* ---------- Theme + group (sub types 3 & 4) ---------- */}
                {(subQuizType === 3 || subQuizType === 4) && (
                  <section className="cq-section">
                    <h3 className="cq-section__title">Theme and group</h3>
                    <p className="cq-section__hint">
                      Changing the theme clears the selected sub-themes and
                      groups.
                    </p>
                    <div className="cq-grid">
                      <div className="cq-field cq-field--wide">
                        <label className="cq-label">Theme</label>
                        <select
                          className="cq-select"
                          value={quizForm.theme_id || ""}
                          onChange={(e) => {
                            const { value } = e.target;
                            // A theme change invalidates sub-themes, groups and
                            // the count table (all validated against the old one).
                            dispatch(
                              setState({ key: "selectedSubThemes", value: [] }),
                            );
                            setGroupId([]);
                            setCountInfo(null);
                            handleChange("theme_id", value);
                          }}
                        >
                          <option value="">Select theme</option>
                          {themes.map((t) => {
                            const id = t.theme_id ?? t.id;
                            const label = t.name ?? t.title ?? `Theme ${id}`;
                            return (
                              <option key={id} value={id}>
                                {label}
                              </option>
                            );
                          })}
                        </select>
                      </div>

                      {quizForm.theme_id && subThemes?.length > 0 && (
                        <div className="cq-field cq-field--wide">
                          <span className="cq-label">Sub themes</span>
                          <div className="cq-chips">
                            {subThemes.map((e) => {
                              const selected = selectedSubThemes || [];
                              const themeId = Number(e.theme_id);
                              return (
                                <label key={e.theme_id} className="cq-chip">
                                  <input
                                    type="checkbox"
                                    value={themeId}
                                    checked={selected.some(
                                      (id) => Number(id) === themeId,
                                    )}
                                    onChange={(event) =>
                                      handleSubThemeCheckboxToggle(
                                        themeId,
                                        event.target.checked,
                                      )
                                    }
                                  />
                                  {e.name}
                                </label>
                              );
                            })}
                          </div>
                        </div>
                      )}

                      <div className="cq-field cq-field--wide">
                        <span className="cq-label">Groups</span>
                        {error && <p className="cq-error">{error}</p>}
                        <div className="cq-chips">
                          {groups && groups.length > 0 ? (
                            groups.map((g) => (
                              <label key={g.group_id} className="cq-chip">
                                <input
                                  type="checkbox"
                                  value={g.group_id}
                                  checked={groupId.includes(g.group_id)}
                                  onChange={(e) =>
                                    handleGroupCheckboxToggle(
                                      g,
                                      e.target.checked,
                                    )
                                  }
                                />
                                {g.group_name}
                              </label>
                            ))
                          ) : (
                            <p className="cq-help">No groups available</p>
                          )}
                        </div>
                      </div>
                    </div>
                  </section>
                )}

                {/* ---------- Difficulty allotment (Live only) ---------- */}
                {quizType === 1 && (
                  <section className="cq-section">
                    <h3 className="cq-section__title">Question allotment</h3>
                    <p className="cq-section__hint">
                      Split the questions across difficulty levels. The total
                      must be exactly 100%.
                    </p>

                    <div className="cq-field" style={{ maxWidth: 260 }}>
                      <label className="cq-label">Add difficulty level</label>
                      <select
                        className="cq-select"
                        onChange={(e) => handleAllotmentChange(e.target.value)}
                        value=""
                      >
                        <option value="">Select</option>
                        {["basic", "advanced", "ultra", "docmaster"].map(
                          (level) => (
                            <option key={level} value={level}>
                              {level}
                            </option>
                          ),
                        )}
                      </select>
                    </div>

                    <div className="cq-allot" style={{ marginTop: 14 }}>
                      {state.allotments.map((each, index) => (
                        <div className="cq-allot__item" key={index}>
                          <span className="cq-allot__name">
                            {each.difficulty_level}
                          </span>
                          <input
                            type="number"
                            placeholder="0"
                            value={each.percentage}
                            min={0}
                            onChange={(e) => {
                              const value = Number(e.target.value);
                              if (value >= 0) updatePercent(index, value);
                            }}
                            onKeyDown={(e) => {
                              if (e.key === "-" || e.key === "e")
                                e.preventDefault();
                            }}
                          />
                          <span>%</span>
                          <button
                            type="button"
                            className="cq-allot__remove"
                            title="Remove"
                            aria-label={`Remove ${each.difficulty_level}`}
                            onClick={() =>
                              removeAllotment(each.difficulty_level)
                            }
                          >
                            ✕
                          </button>
                        </div>
                      ))}
                    </div>

                    <div
                      className={`cq-total ${
                        totalAllotment === 100 ? "is-ok" : "is-bad"
                      }`}
                    >
                      Total {totalAllotment}% (must be 100%)
                    </div>
                  </section>
                )}

                {/* ---------- About, prize, terms ---------- */}
                {quizType && subQuizType && (
                  <>
                    {quizType === 1 && (
                      <section className="cq-section">
                        <h3 className="cq-section__title">
                          Winner prize details
                        </h3>
                        <textarea
                          onChange={(e) =>
                            handleChange("prizeDescription", e.target.value)
                          }
                          value={prizeDescription}
                          className="cq-textarea"
                          placeholder="Describe the prizes for the winners"
                          required
                        />
                      </section>
                    )}

                    <section className="cq-section cq-section--full">
                      <h3 className="cq-section__title">About and terms</h3>
                      <div className="cq-grid cq-grid--split">
                        <div className="cq-field cq-field--wide">
                          <label className="cq-label">About quiz</label>
                          <textarea
                            className="cq-textarea"
                            value={quizForm.about}
                            onChange={(e) =>
                              handleChange("about", e.target.value)
                            }
                            required
                          />
                        </div>

                        <div className="cq-field">
                          <label className="cq-label">
                            Terms and conditions
                          </label>
                          <textarea
                            className="cq-textarea cq-textarea--terms"
                            value={quizForm.terms}
                            onChange={(e) =>
                              handleChange("terms", e.target.value)
                            }
                            required
                          />
                        </div>

                        <div className="cq-field">
                          <span className="cq-label">Preview</span>
                          <div className="cq-preview">
                            {quizType === 2 && (
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: formatTerms(quizForm.terms),
                                }}
                              />
                            )}
                            {quizType === 1 && (
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: convertTermsToHtml(quizForm.terms),
                                }}
                              />
                            )}
                          </div>
                        </div>

                        <div className="cq-field cq-field--wide">
                          <div className="cq-note">
                            <strong>
                              Keep these variables in the terms above:
                            </strong>
                            <ol>
                              <li>[Number] – total number of questions.</li>
                              <li>
                                [X seconds] – total duration, calculated as
                                total questions × duration per question (in
                                seconds).
                              </li>
                              <li>
                                [X second] – duration for each question (in
                                seconds).
                              </li>
                              <li>
                                [Correct] – score awarded for each correct
                                answer.
                              </li>
                            </ol>
                          </div>
                        </div>
                      </div>
                    </section>

                    <div className="cq-actions">
                      <button
                        type="button"
                        className="cq-btn"
                        onClick={handleSubmit}
                      >
                        Create quiz
                      </button>
                    </div>
                  </>
                )}
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
}
